package ai.flowstorm.studio.ui.design.dialogue.panel

import ai.flowstorm.studio.ui.data.DialogueEventTable

class DialogueEventPanel : DialogueEventTable(false, true, false,"panel-view-nav1")
